import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { size, get, map, filter, head, replace } from 'lodash';
import { string, func, bool } from 'prop-types';
import { FlexContainer, Button, FormInput, Row, MobileWrapper, Icon, InputBox } from '../../common';

const SpaceBetween = styled.div`
    min-width: ${({ width }) => width};`;

const TopFilters = ({
    currentValue,
    reseting,
    handleSetStateTopFilter,
    setResetTop,
    resetTop
}) => {
    useEffect(() => {
        if (resetTop) {
            console.log('resetTop');
            setOrderId(null);
            setLastName(null);
            setEmail(null);
            setDocument(null);
            setResetTop(false);
        };
    }, [resetTop]);

    const [orderId, setOrderId] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [email, setEmail] = useState(null);
    const [document, setDocument] = useState(null);
    const [showMobileFilters, setShowMobileFilters] = useState(false);

    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';

    const filters = [
        { name: 'Pedido', filterFunction: setOrderId },
        { name: 'Apellido', filterFunction: setLastName, hide: true },
        { name: 'Mail', filterFunction: setEmail, hide: !showMobileFilters },
        { name: 'Rut', filterFunction: setDocument, hide: !showMobileFilters }
    ];

    const setFilters = (isCleaningFilter = true) => {
        const formattedDocument = replace(document, /[.-\s]/g, '');
        handleSetStateTopFilter(orderId, lastName, email, formattedDocument, isCleaningFilter);
    };

    useEffect(() => {
        size(orderId) === 0 && setFilters();
    }, [ orderId ]);

    useEffect(() => {
        size(lastName) === 0 && setFilters();
    }, [ lastName ]);

    useEffect(() => {
        size(email) === 0 && setFilters();
    }, [ email ]);

    useEffect(() => {
        size(document) === 0 && setFilters();
    }, [ document ]);

    const onPressEnter = ({ key }) => {
        key === 'Enter' && setFilters(false);
    };

    const handleInputValue = (filterName, event) => {
        const value = get(event, 'target.value', null);
        const filterFound = head(filter(filters, ({ name }) => name === filterName));
        filterFound['filterFunction'](value);
    };

    if (reseting) return null;

    const getValue = (name) => {
        if (name === 'Rut') return document;
        if (name === 'Apellido') return lastName;
        if (name === 'Pedido') return orderId;
        if (name === 'Mail') return email;
    };

    return (
        <FlexContainer pY={23}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='3px 13px'
                noWrap={!fullWidth}
            >
                <MobileWrapper>
                    <FlexContainer justify='flex-end' flex={1} mB={-20}>
                        <Icon
                            name={!showMobileFilters ? 'chebron_up' : 'chebron_down'}
                            color='#A4C735'
                            top={9}
                            pointer
                            onClick={() => setShowMobileFilters(!showMobileFilters)}
                            zIndex={1}
                        />
                    </FlexContainer>
                </MobileWrapper>
                {map(filters, ({ name, hide = false }, index) => (
                    <MobileWrapper key={index} hide={hide} showDesktop>
                        {name === "Pedido" ? (
                            <InputBox 
                                label={name}
                                onChange={(value) => setOrderId(value)}
                            />
                        ) : (
                            <FormInput
                                label={name}
                                onChange={(event) => handleInputValue(name, event)}
                                onKeyPress={onPressEnter}
                                isDocumentId={name === "Rut"}
                                value={getValue(name)}
                            />
                        )}
                        <SpaceBetween width={spaceBetweenWidth} />
                    </MobileWrapper>
                ))}
                <FlexContainer
                    width={fullWidth ? '100%' : undefined}
                    align='flex-end'
                    mB={10}
                    display={'block'}
                >
                    <Button
                        text='Buscar'
                        style={{ marginTop: '30px' }}
                        onClick={() => setFilters(false)}
                    />
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

TopFilters.propTypes = {
    currentValue: string,
    handleSetStateTopFilter: func,
    reseting: bool,
    setResetTop: func,
    resetTop: bool
};

TopFilters.defaultProps = {
    currentValue: '100%',
    handleSetStateTopFilter: () => {},
    reseting: false
};

export default TopFilters;
